import { render, staticRenderFns } from "./summary-cash-collection.vue?vue&type=template&id=2a0aff39"
import script from "./summary-cash-collection.vue?vue&type=script&lang=js"
export * from "./summary-cash-collection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports